<template>
  <div class="courseware_wrap">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      
    }
  },
  created() {
    
  },
  mounted() {
    
  },
}
</script>
<style lang="scss">
  .courseware_wrap{
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/courseware/courseware.vue